import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.string.split";
import React, { Fragment } from 'react';
import { isBlank, isPresent } from 'helpers/verify';
var VARIABLE_REGEX = /(\$[a-zA-Z]\w*)/;

function interpolateToArray(text) {
  var replacementByVariable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isBlank(text)) {
    return [];
  }
  /* eslint-disable no-nested-ternary */


  return text.split(VARIABLE_REGEX).map(function (segment) {
    return !(VARIABLE_REGEX.test(segment) && segment in replacementByVariable) ? segment : isPresent(replacementByVariable[segment]) ? replacementByVariable[segment] : '';
  });
  /* eslint-enable no-nested-ternary */
}

export var interpolate = function interpolate() {
  return interpolateToArray.apply(void 0, arguments).join('');
};
export var interpolateToJsx = function interpolateToJsx() {
  return interpolateToArray.apply(void 0, arguments) // eslint-disable-next-line react/no-array-index-key
  .map(function (bit, idx) {
    return React.createElement(Fragment, {
      key: "".concat(bit, "_").concat(idx)
    }, bit);
  });
};